{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Válasszon ki egy elemet",
  "tableResizer": "Átméretező",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
